export enum AreaType {
  ZIP_CODE = 'zip_code',
  LOCALITY = 'locality',
}
